<custom-modal-card *ngIf="{} as STATE" class="mat-dialog-transparent">
  <ng-container header>
    <default-modal-header
      [title]="modalTitle"
      [description]="modalDescription"
    ></default-modal-header>
  </ng-container>
  <ng-container body>
    <form [formGroup]="form" class="resource-form">
      <article>
        <file-upload
          (fileChange)="setFile($event)"
          [preloadedFiles]="
            program?.banner ? [program!.banner!.attachment!] : []
          "
          [label]="'Faites glisser la bannière ici.'"
          [accept]="supportedImageExtensions"
          [maxSize]="2_388_608"
        ></file-upload>
        <!-- <file-tab [tabs]="fileTabs" [defaultTab]="selectedFileTab">
          <file-upload
            (fileChange)="setFile('teaser', $event)"
            [preloadedFiles]="
              program?.teaser ? [program!.teaser!.attachment!] : []
            "
            [label]="'Faites glisser le teaser ici.'"
            [accept]="supportedVideoExtensions"
            [maxSize]="8_388_608"
          ></file-upload>
          
        <mat-error *ngIf="teaserControl?.getError('httpError') as httpError">
          <strong>Teaser: {{ httpError }}</strong>
        </mat-error>
        </file-tab> -->
        <mat-error *ngIf="bannerControl?.getError('httpError') as httpError">
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Titre de la bannière *</mat-label>
        <mat-form-field>
          <input
            formControlName="bannerTitle"
            matInput
            placeholder="Entrez un titre (100 charactères max)."
          />
        </mat-form-field>
        <mat-error
          *ngIf="form.get('bannerTitle')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Couleur du titre</mat-label>
        <color-picker-bar
          (colorChange)="setColor($event)"
          [colors]="colors"
          [defaultColor]="form.get('bannerTitleColor')?.value || defaultColor"
        ></color-picker-bar>
        <mat-error
          *ngIf="
            form.get('bannerTitleColor')?.getError('httpError') as httpError
          "
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Description de la bannière *</mat-label>
        <mat-form-field>
          <textarea
            formControlName="bannerDescription"
            matInput
            rows="3"
            placeholder="Entrez le texte à afficher (200 charactères max)."
          ></textarea>
        </mat-form-field>
        <mat-error
          *ngIf="
            form.get('bannerDescription')?.getError('httpError') as httpError
          "
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Couleur de la description</mat-label>
        <color-picker-bar
          (colorChange)="setColor($event, 'bannerDescriptionColor')"
          [colors]="colors"
          [defaultColor]="
            form.get('bannerDescriptionColor')?.value || defaultColor
          "
        ></color-picker-bar>
        <mat-error
          *ngIf="
            form
              .get('bannerDescriptionColor')
              ?.getError('httpError') as httpError
          "
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
    </form>
  </ng-container>
  <footer footer class="resource-form">
    <button
      (click)="update()"
      [attr.loading]="isLoading"
      [disabled]="!isFormValid || isLoading"
      class="btn btn--primary-light btn--full"
    >
      Sauvegarder la bannière
    </button>
  </footer>
</custom-modal-card>
